var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline-block" } },
    [
      _c(
        "v-tooltip",
        {
          attrs: { top: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  return [
                    _c(
                      "span",
                      _vm._g(
                        {
                          on: {
                            click: function($event) {
                              _vm.dialog = true
                            }
                          }
                        },
                        on
                      ),
                      [
                        _vm._t("default", [
                          _vm.$store.state.DelegationOrder.readonly !== true
                            ? _c(
                                "v-btn",
                                { attrs: { icon: "" } },
                                [_c("v-icon", [_vm._v("fa-file-import")])],
                                1
                              )
                            : _vm._e()
                        ])
                      ],
                      2
                    )
                  ]
                }
              }
            ],
            null,
            true
          )
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("delegationOrder.importTravelServiceOrders")) +
              " "
          )
        ]
      ),
      _c(
        "v-dialog",
        {
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.$t("travelService.orderList")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: _vm.$t("global.search") },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.travelServiceOrdersWithoutAlreadyImported,
                      "item-key": "id",
                      search: _vm.search,
                      "custom-filter": _vm.filterOverAllProperty
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function(props) {
                          return [
                            _c("tr", [
                              _c(
                                "td",
                                [
                                  _c("v-checkbox", {
                                    staticClass: "mt-0",
                                    staticStyle: { width: "5px" },
                                    attrs: { "hide-details": "" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(props.item.created_at))]),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(_vm.getStatusText(props.item)))
                              ]),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                _vm._l(
                                  props.item.travelServiceOrderItems,
                                  function(orderItem) {
                                    return _c("order-services-request-dates", {
                                      key: orderItem.id,
                                      attrs: { "order-service-item": orderItem }
                                    })
                                  }
                                ),
                                1
                              ),
                              _c("td", {
                                staticClass: "text-center",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getServicesHtml(props.item)
                                  )
                                }
                              }),
                              _c("td", {
                                staticClass: "text-center",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getPersonsHtml(props.item)
                                  )
                                }
                              })
                            ])
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.selected,
                      callback: function($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "blue darken-1" },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "blue darken-1" },
                      on: { click: _vm.importOrder }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.import")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }